var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    width: 19,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 19,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAAXNSR0IB2cksfwAAAYxQTFRFAj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+KIOfNAAAAIR0Uk5TABSo6OzqvSqe//ft8swflKFb6/UoDxXaTniMMAvXyp+Q4HS883tTnbbEBED++0odERguE2Z+uXyZYqxI8EeG0LMCx4rxNPk9JNwNvwzSRrJrl+EKPOmHLQGpV2r2X5UDzWHui/07oyzdTaWSbHqvOpEXZefkVW+tt961gBDPeXEGDvp2AppIJwAAASlJREFUeJxNkOkzQgEUxS+pHO8RUUlZolB5iielkhBlyV7IXlmy7/vuH3efZnA+/c6dM3fOHKIflZSqytQaLf1XOSoEEZW/vkpXXaOvrTMYTag3N1iUk7URrCamZgVE5UELbK1tdgdTO1QdnXC6yN0ldRN5yKvtoV6ZDDb0kQ/9yge/CmLAxTCAIIUQHiSKAEN2RIdJHoGPaBSxMXlcjFNiAvFJJ6amOa1BcgazDD7MzWNhkWkphfQykitEq8isYX2DyCJgk7a2Ed0JIGukHPK7XG+Pw/sHXDdcYDrEETmQVroYjnUnHgVO4SejKX/mzZxfsE1EQtZLXDG6YdcDZr4FgWsJN0r6Vp+9k+4ZHvCYEp6KYz176UV6fcsh9v4h/21aUEvSp/BVNN/Z2y5dnkVM3AAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/settingIcon.e2fbe43001614e409808bc01ed4cf04f.svg";
export { ForwardRef as ReactComponent };